export default `
	teasers {
		...on TeasersItem {
			teaserSquare {
				filename
				height
				id
				size
				url(transform:teaserSquare)
				width
			}
			teaserPortrait {
				filename
				height
				id
				size
				url(transform:coverImage)
				width
			}
		}
	}
`;
